import { render } from "./PharmacyComponent.vue?vue&type=template&id=5b4460a3&scoped=true"
import script from "./PharmacyComponent.vue?vue&type=script&lang=js"
export * from "./PharmacyComponent.vue?vue&type=script&lang=js"

import "./PharmacyComponent.vue?vue&type=style&index=0&id=5b4460a3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b4460a3"]])

export default __exports__